.list {
  display: table;
}

.list--striped-with-bp {
  .row {
    &:nth-of-type(4n-1),
    &:nth-of-type(4n) {
      background-color: var(--dds-color-surface-default);
    }

    &:nth-of-type(4n-3),
    &:nth-of-type(4n-2) {
      background-color: var(--dds-color-surface-subtle);
    }
  }
}

.list--small {
  dt,
  dd {
    padding: var(--dds-spacing-x0-5);
  }
}

.list--medium {
  dt,
  dd {
    padding: var(--dds-spacing-x0-75);
  }
}

.list--large {
  dt,
  dd {
    padding-block: var(--dds-spacing-x1-5);
    padding-inline: var(--dds-spacing-x0-75);
  }
}

.column {
  dt,
  dd {
    margin-inline-start: 0;
    text-align: left;
  }
  dt {
    padding-block-end: var(--dds-spacing-x0-125);
  }

  dd:not(:last-of-type) {
    padding-block: var(--dds-spacing-x0-125);
  }

  dd:last-of-type {
    padding-block-start: var(--dds-spacing-x0-125);
  }
}

.cell {
  display: table-cell;
}

.term {
  font-weight: var(--dds-font-weight-bold);
}
